<div fxFlex="100">
  <div fxLayout="row" class="">

    <div *ngIf="!licensed && !verifyingLicense && isSuperAdmin" fxLayout="row" fxLayoutAlign="center center">
      <div *ngIf="this.license && this.license.subscriptions" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="6px">
        <mat-icon class="icon-20" [ngClass]="{'amber-200-fg': iconColor === 'amber', 'red-600-fg': iconColor === 'red'}">warning</mat-icon>
        <p>Little SIS license for <strong>{{this.license.domain}}</strong> expired on {{(this.license.subscriptions['ait-lsp'].plan.paid_ended_at? this.license.subscriptions['ait-lsp'].plan.paid_ended_at : this.license.subscriptions['ait-lsp'].plan.trial_ended_at) | date: 'MM/dd/yyyy'}}.</p>
        <button mat-flat-button *ngIf="isSuperAdmin" (click)="openLicensingRenewalDialog()">Renew</button>
      </div>

    </div>



    <div *ngIf="licensed && !verifyingLicense" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">

      <div *ngIf="showIcon === true" fxLayoutAlign="center center" fxLayout="row">
        <mat-icon class="icon-20" [ngClass]="{'amber-200-fg': iconColor === 'amber', 'red-600-fg': iconColor === 'red'}">warning</mat-icon>
      </div>

      <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="6px">
        <p class="renew-link" *ngIf="isSuperAdmin && showIcon === true; else standardUser" (click)="openLicensingRenewalDialog()">
          {{expiryMessage}}
        </p>
        <ng-template #standardUser>{{expiryMessage}}</ng-template>
      </div>
    </div>

    <app-licensing-tester *ngIf="showLicenseTestPanel"></app-licensing-tester>

    <div *ngIf="verifyingLicense" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">

      <mat-progress-spinner [diameter]="12"
                            [color]="'primary'"
                            [mode]="'indeterminate'">
      </mat-progress-spinner>

      <div class="loading">
        <span>Checking license</span>
        <animated-ellipsis></animated-ellipsis>
      </div>

    </div>

  </div>

</div>
